var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.58496C18.5764 4.58496 18.8096 4.68154 18.9815 4.85345C19.1534 5.02535 19.25 5.25851 19.25 5.50163C19.25 5.74474 19.1534 5.9779 18.9815 6.14981C18.8096 6.32172 18.5764 6.41829 18.3333 6.41829H17.4167L17.4139 6.48338L16.5587 18.4651C16.5257 18.9277 16.3188 19.3605 15.9794 19.6766C15.6401 19.9926 15.1936 20.1683 14.7299 20.1683H7.26917C6.80546 20.1683 6.35898 19.9926 6.01964 19.6766C5.68031 19.3605 5.47334 18.9277 5.44042 18.4651L4.58517 6.48429C4.58378 6.46232 4.58316 6.44031 4.58333 6.41829H3.66667C3.42355 6.41829 3.19039 6.32172 3.01849 6.14981C2.84658 5.9779 2.75 5.74474 2.75 5.50163C2.75 5.25851 2.84658 5.02535 3.01849 4.85345C3.19039 4.68154 3.42355 4.58496 3.66667 4.58496H18.3333ZM15.5806 6.41829H6.41942L7.27008 18.335H14.7299L15.5806 6.41829ZM12.8333 1.83496C13.0764 1.83496 13.3096 1.93154 13.4815 2.10345C13.6534 2.27535 13.75 2.50851 13.75 2.75163C13.75 2.99474 13.6534 3.2279 13.4815 3.39981C13.3096 3.57172 13.0764 3.66829 12.8333 3.66829H9.16667C8.92355 3.66829 8.69039 3.57172 8.51849 3.39981C8.34658 3.2279 8.25 2.99474 8.25 2.75163C8.25 2.50851 8.34658 2.27535 8.51849 2.10345C8.69039 1.93154 8.92355 1.83496 9.16667 1.83496H12.8333Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDark);
export default __webpack_public_path__ + "static/media/deleteDark.e528b1ce3cf78e3e8a5a45eeb6a06f87.svg";
export { ForwardRef as ReactComponent };